import axios from "axios";
import React, { useEffect, useState } from "react";
import CreaPreguntas from "./CreaPreguntas";

function Encuestas() {
  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/ObtenerTipoEncuestas",
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);
  return (
    <div className="container">
      <div className="text-center">
        <div class="container-fluid">
          <div class="card shadow mb-4">
            <div class="card-header py-3">
              <h6 class="m-0 font-weight-bold text-primary">
                Instrumentos Evaluativos
              </h6>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table
                  class="table table-bordered"
                  id="dataTableAyB"
                  width="100%"
                  cellspacing="0"
                >
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>nombre de la encuesta</th>
                      <th>Preguntas</th>
                    </tr>
                  </thead>

                  <tbody>
                    {list.map((item) => {
                      return (
                        <tr>
                          <td>{item.id}</td>
                          <td>{item.nombre}</td>
                          <td>
                            <CreaPreguntas idEncuesta={item.id} />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Encuestas;
